import React, { useState } from 'react';
import { generateBookingReceipt } from '../../utils/pdfReceipt';
import { BookingsDocument } from '../../types';

// Sample booking data for testing
const sampleBooking: BookingsDocument = {
  id: 'TEST-BOOKING-001',
  slotId: 'SLOT-001',
  inventoryId: 'INV-001',
  couponCode: 'WELCOME10',
  userId: 12345,
  userName: 'John Doe',
  phoneNumber: '+91 9876543210',
  email: 'john.doe@example.com',
  actualAmount: 11547,
  ticketAmount: 10000,
  orderAmount: 9899,
  amountPaid: 9899,
  totalDiscount: 1648,
  createdOn: Date.now(),
  modifiedOn: Date.now(),
  status: 'Paid',
  tripDate: '2024-02-15',
  startTime: Date.now() + 86400000, // Tomorrow
  eventImage: 'https://example.com/event.jpg',
  eventName: 'Mysore Palace & Chamundi Hills Day Trip',
  convenienceFee: 100,
  count: 2,
  travellers: [
    {
      id: 'TRAV-001',
      name: 'John Doe',
      email: 'john.doe@example.com',
      gender: 1,
      phoneNumber: '+91 9876543210',
      whatsAppNumber: '+91 9876543210',
      tripLocation: {
        id: 'LOC-001',
        name: 'Mysore Palace',
        url: 'https://maps.google.com/mysore-palace',
        displayText: 'Mysore Palace, Karnataka',
        seqNo: 1
      },
      primaryUser: true,
      cancelled: false,
      amountRefunded: 0,
      present: true
    },
    {
      id: 'TRAV-002',
      name: 'Jane Doe',
      email: 'jane.doe@example.com',
      gender: 2,
      phoneNumber: '+91 9876543211',
      whatsAppNumber: '+91 9876543211',
      tripLocation: {
        id: 'LOC-001',
        name: 'Mysore Palace',
        url: 'https://maps.google.com/mysore-palace',
        displayText: 'Mysore Palace, Karnataka',
        seqNo: 1
      },
      primaryUser: false,
      cancelled: false,
      amountRefunded: 0,
      present: true
    }
  ],
  partialPaymentAlertShown: false,
  kidAlertShown: false,
  hasKids: false,
  remark: 'Please ensure timely pickup from the designated location.',
  deleted: false,
  remainingAmountLink: 'https://payment.boz.com/remaining/123',
  successfulPaymentCount: 1,
  searchIndex: 'john doe mysore palace',
  source: 'Website',
  amountRemaining: 0,
  npsIdCreated: false,
  whatsAppSmsSent: true,
  gateway: 'Razorpay',
  gstAmount: 1780,
  subText: 'Confirmed',
  driveLink: 'https://drive.google.com/mysore-trip-details',
  canEdit: true,
  canReschedule: true,
  bookingRefId: 'BOZ-2024-001',
  paymentReminderTime: Date.now() + 3600000, // 1 hour from now
  paymentCount: 1
};

export const PDFTestComponent: React.FC = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleTestPDF = async () => {
    setIsGenerating(true);
    try {
      await generateBookingReceipt(sampleBooking);
      console.log('PDF generation test completed successfully!');
    } catch (error) {
      console.error('PDF generation test failed:', error);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="p-4 bg-gray-100 rounded-lg">
      <h3 className="text-lg font-semibold mb-4">PDF Receipt Test with Logo</h3>
      <p className="text-gray-600 mb-4">
        Click the button below to test PDF receipt generation with the actual BOZ logo.
      </p>
      <button
        onClick={handleTestPDF}
        disabled={isGenerating}
        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isGenerating ? 'Generating PDF...' : 'Generate Test Receipt with Logo'}
      </button>
      
      {isGenerating && (
        <div className="mt-4 text-sm text-gray-600">
          <p>⏳ Loading company logo and generating PDF...</p>
        </div>
      )}
    </div>
  );
};

export default PDFTestComponent;